import { render, staticRenderFns } from "./CategoryItems.vue?vue&type=template&id=015c5d7c&scoped=true"
import script from "./CategoryItems.vue?vue&type=script&lang=js"
export * from "./CategoryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c5d7c",
  null
  
)

export default component.exports